import React, { Component } from "react";

class Footer extends Component {
  constructor(props) {
    super(props);

    var params = new URLSearchParams(window.location.search);

    this.state = {
      uid: params.get("uid"),
      locale: params.get("locale")
    };
  }

  render() {
    return (
      <footer className="footer text-center">
        {this.state.uid && <div>{(this.state.locale === 'ru' || this.state.locale === 'kk') ? 'Твой ID: ' : 'Your ID: '}{this.state.uid}</div>}
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js